import React, { useState, useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Input,
  Button,
  Password,
  LoginLayout,
  Toast,
  Icon,
} from "@app/components";
import { emailPattern, passwordPattern, useLocation } from "@app/utils";
import { createUser, validateEmail, DataService, getAddress } from "@app/services";
import { privacyUrl, termsUrl, getDefaultUrl } from "@app/routes/route-helpers";
import { AuthContext } from "@app/providers";
import {
  FormFlexWrapper,
  FlexWrapper,
  Error,
  DropdownWrapper,
  CommonLabel,
  SelectCustomStyles
} from "@app/components/commonStyles";
import { PopUpContainer, PopUpSubTitle, PopUpText, PopUpTitle, PopUpWrapper } from "@app/components/success-modal/success-modal-components";
import {
  Container,
  ButtonContainer
} from "../sign-up.component";
import SuccessModal from '../../../components/success-modal/success-modal'
import Select from "react-select";
import {
  stateList,
  capitalize,
} from "@app/utils";

export default function ParentSignupFirst() {
  const { handleSubmit, trigger, register, watch, errors, getValues, clearErrors, control, setValue }: any =
    useForm({ mode: "onBlur" });
  const { navigate } = useLocation();
  const { setUserInfo } = useContext(AuthContext);
  const [buttonText, setButtonText] = useState<string>("Sign Up");
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [parentData, setParentData] = useState<any>({});
  const [zipServerErr, setZipServerErr] = useState('')
  const [zipError, setZipError] = useState<boolean>(false);
  const [checkedTerms, setCheckedTerms] = useState<boolean>(false);
  const [checkedErr, setCheckedErr] = useState<boolean>(false);
  const [emailValidation, SetEmailValidation] = useState<any>({
    isEmailValid: false,
    validate: false,
    emailError: false,
  });
  const [showToast, setShowToast] = React.useState(false);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const [showSuccessPopUp, setShowSuccessPopUp] = React.useState(false);
  const [successMessage, setSuccessMessage] = useState<any>({
    type: "sucess",
    title: "Sign up completed!",
    subtitle: "Thank you for signing up kazoobadoo",
    text: "Please check your inbox and click on the verification link to verify your account"
  });
  const STRIPEKEY = process.env.REACT_APP_STRIPEKEY || "";

  useEffect(() => {
    // const platform = window.navigator.platform
    // setShowToast(true);
    // setToastMessage({
    //   type: "error",
    //   message: getUA()
    // });
    // setTimeout(() => {
    //   setShowToast(false)
    // }, 100)
  }, [])



  // console.log(getUA());





  function onChange(data: any) {
    if (data.target.name === "zip") {
      setValue("city", "");
      setValue("state", "");
      if (data.target.value.length === 5) {
        setZipError(false);
      }
    }
  }

  function onPasswordBlur(evt: any) {
    if (getValues("confirmPassword")) {
      trigger("confirmPassword");
    }
    if (passwordPattern.test(evt.target.value)) {
      clearErrors("password")
    }
  }
  function onConfirmPassBlur(evt: any) {
    if (passwordPattern.test(evt.target.value)) {
      clearErrors("confirmPassword")
    }
  }

  function onEmailBlur() {
    const emailValue = getValues("email");
    if (emailValue) {
      SetEmailValidation({ ...emailValidation, validate: true });
      validateEmail({ email: emailValue })
        .then((response: any) => {
          if (response._responseStatus === 1) {
            SetEmailValidation({
              isEmailValid: true,
              validate: false,
              emailError: false,
            });
          } else {
            SetEmailValidation({
              isEmailValid: false,
              validate: false,
              emailError: true,
            });
          }
        })
        .catch((err: any) => {
          SetEmailValidation({
            isEmailValid: false,
            validate: false,
            emailError: true,
          });
          console.log(err);
        });
    }
  }

  function onSubmit(data: any) {
    // console.log(data)
    setCheckedErr(false)
    const param: any = {}
    Object.assign(param, {
      termsOfService: checkedTerms || false,
      ...data
    })
    // console.log(param)
    if (param.termsOfService === false) {
      setCheckedErr(true)
      return false
    }
    if (checkedTerms == false) {
      return false
    }
    if (emailValidation.emailError || zipError) return;
    const params: any = {};
    Object.assign(params, {
      userType: "parent",
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      password: data.password,
      confirmPassword: data.confirmPassword,
      termsOfService: 1,
      city: data.city,
      state: data.state.value,
      zip: data.zip,
    });
    setButtonText("Signing Up...");
    createUser(params)
      .then((response: any) => {
        setButtonText("Sign Up");
        if (response._responseStatus === 1) {
          // console.log(response)
          setShowSuccessPopUp(true);
          setParentData(response);
          setShowSuccess(true);
          localStorage.setItem("paymentUser", JSON.stringify({ ...params, userId: response.userId }));
          localStorage.setItem("paymentSource", "signUp");
          localStorage.setItem("parentDataSource", JSON.stringify(response));
          // const defaultUrl: string = getDefaultUrl(response.userJson);
          // if(response.userJson['ageVerfiedflag']){
          //   navigate(defaultUrl);
          // }

          // setUserInfo(response)           
          // const defaultUrl: string = getDefaultUrl(response.userJson);
          // navigate(defaultUrl);
        } else {
          setShowToast(true);
          setToastMessage({
            type: "error",
            message: response.msg,
          });
        }
      })
      .catch((err: any) => {
        setButtonText("Sign Up");
        console.log(err, "createParentError");
        setShowToast(true);
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
      });
  }


  function redirectToProfile() {
    DataService.sendMessage({ key: "userJson", data: parentData.userJson });
    localStorage.setItem("userData", JSON.stringify(parentData));
    setUserInfo(parentData);
    const defaultUrl = getDefaultUrl(parentData && parentData.userJson);
    navigate(defaultUrl);
  }

  function navigateToSignup() {
    navigate("/sign-up");
  }
  function onCancel() {
    setShowSuccessPopUp(false)
    navigate('/sign-in/parent');
  }
  function onZipBlur(data: any) {
    setZipServerErr('')
    if (data.target.value.length !== 5) {
      setZipError(true);
      return;
    }
    setZipError(false);
    getAddress(data.target.value)
      .then((res) => {
        if (res && !res.error) {
          setValue("city", capitalize(res.city));
          clearErrors("city");
          const selectedState = stateList.find(
            (state) => state.value === res.state
          );
          setValue("state", selectedState);
          clearErrors("state");
        }
        else {
          setZipServerErr(res.error)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // if (!showSuccess) {
  return (
    <>
      <LoginLayout path="" label="">
        <Toast
          message={toastMessage.message}
          showToast={showToast}
          type={toastMessage.type}
          onClose={() => setShowToast(false)}
        />
        <Container>
          <h3 className="primary-header text-center mb-3">
            Home Account Sign Up
          </h3>
          <h4 className="secondary-header text-center mb-3">
            Create a Parent Account
          </h4>
          <form onSubmit={handleSubmit(onSubmit)} onChange={onChange}>
            <FormFlexWrapper className="two-child-layout mb-0">
              <div className="child mb-0">
                <Input
                  hideLabel={false}
                  label="First Name"
                  placeholder="First Name"
                  name="firstName"
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  error={errors.firstName && "Please enter First Name"}
                />
              </div>
              <div className="child">
                <Input
                  hideLabel={false}
                  label="Last Name"
                  placeholder="Last Name"
                  name="lastName"
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  error={errors.lastName && "Please enter Last Name"}
                />
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <Input
                  hideLabel={false}
                  type="number"
                  label="Zip Code"
                  placeholder="Zip Code"
                  name="zip"
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  maxLength={5}
                  onChange={onZipBlur}
                  error={
                    (errors.zip && "Please enter Zip Code") ||
                    (!errors.zip && zipError && "Please enter valid Zip Code") ||
                    zipServerErr
                  }
                />
              </div>

            </FormFlexWrapper>
            <FormFlexWrapper className="two-child-layout">
              <div className="child">
                <Input
                  hideLabel={false}
                  label="City"
                  placeholder="City"
                  name="city"
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  error={errors.city && "Please enter City"}
                />
              </div>
              <div className="child mb-0">
                <DropdownWrapper>
                  <CommonLabel className="label-color">State</CommonLabel>
                  <Controller
                    as={Select}
                    value="value"
                    name="state"
                    options={stateList}
                    placeholder="State"
                    control={control}
                    rules={{ required: true }}
                    styles={SelectCustomStyles}
                    defaultValue={""}
                  />
                  {errors.state && <Error>Please select State</Error>}
                </DropdownWrapper>
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <Input
                  hideLabel={false}
                  type="email"
                  label="Email Address"
                  placeholder="Email Address"
                  name="email"
                  register={register({
                    required: true,
                    pattern: emailPattern,
                  })}
                  onBlur={onEmailBlur}
                  className={
                    !errors.email && emailValidation.isEmailValid ? "valid" : ""
                  }
                  isValid={
                    !errors.email &&
                    !emailValidation.validate &&
                    emailValidation.isEmailValid
                  }
                  validating={!errors.email && emailValidation.validate}
                  error={
                    (errors.email &&
                      errors.email.type === "required" &&
                      "Please enter Email Address") ||
                    (errors.email &&
                      errors.email.type === "pattern" &&
                      "Please enter valid Email Address") ||
                    (!errors.email &&
                      emailValidation.emailError &&
                      "Email already exists. Please try with another Email.")
                  }
                />
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <Password
                  label="Password"
                  hideLabel={false}
                  hideIcon={true}
                  placeholder="Password"
                  name="password"
                  showInfo={false}
                  showInstructions={true}
                  register={register({
                    required: true,
                    pattern: passwordPattern,
                  })}
                  onChange={onPasswordBlur}
                  error={
                    (errors.password &&
                      errors.password.type === "required" &&
                      "Please enter Password") ||
                    (errors.password &&
                      errors.password.type === "pattern" &&
                      "Please enter a Strong Password")
                  }
                />
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <Password
                  label="Confirm Password"
                  hideLabel={false}
                  hideIcon={true}
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  onChange={onConfirmPassBlur}
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value === watch("password");
                    },
                  })}
                  error={
                    (errors.confirmPassword &&
                      errors.confirmPassword.type === "required" &&
                      "Please confirm Password") ||
                    (errors.confirmPassword &&
                      errors.confirmPassword.type === "validate" &&
                      "Passwords did not match")
                  }
                />
              </div>
            </FormFlexWrapper>

            <FormFlexWrapper className="mb-3">
              <div className="child only-child">
                <label className="custom-checkbox-container mb-0">
                  <input type="checkbox"
                    ref={register({})}

                    onChange={() => {
                      setCheckedTerms(!checkedTerms)
                    }} defaultChecked={checkedTerms} value={""} />
                  <span className="checkmark"></span>
                  <span>I agree to KazooBadoo's</span>
                  <a
                    href={termsUrl}
                    rel="noopener noreferrer"
                    className="anchor-tag"
                  >
                    Terms of Use
                  </a>
                  and
                  <a
                    href={privacyUrl}
                    rel="noopener noreferrer"
                    className="anchor-tag"
                  >
                    Privacy Policy
                  </a>
                </label>
                {/* <label className="custom-checkbox-container mb-0">
                  I agree to KazooBadoo's{" "}
                  <a
                    target="_blank"
                    href={termsUrl}
                    rel="noopener noreferrer"
                    className="anchor-tag p-0"
                  >
                    Terms of Use
                  </a>{" "}
                  and{" "}
                  <a
                    target="_blank"
                    href={privacyUrl}
                    rel="noopener noreferrer"
                    className="anchor-tag p-0"
                  >
                    {" "}
                    Privacy Policy
                  </a>
                  <input
                    type="checkbox"
                    name="termsOfService"
                    ref={register({ required: true })}
                    value="true"
                  />
                  <span className="checkmark"></span>
                </label> */}
                {checkedErr && checkedTerms === false && (
                  <Error className="checkbox-error">
                    You need to agree Terms of Use and Privacy Policy
                  </Error>
                )}
              </div>
            </FormFlexWrapper>
            <ButtonContainer disabled={buttonText === "Signing Up..."}>
              <Button
                variant="newsecondary"
                size="large"
                width="100%"
                type="submit"
                onClick={() => {
                  if (checkedTerms === false) {
                    setCheckedErr(true)
                  }
                }}
              >
                {buttonText}
              </Button>
            </ButtonContainer>
            <ButtonContainer style={{ marginTop: "15px" }}>
              <Button onClick={() => navigateToSignup()}
                variant="bordered"
                size="large"
                width='100%'>
                Cancel
              </Button>
            </ButtonContainer>
            <FlexWrapper className="justify-between mt-2">
              <p className="m-0">
                Already have an account?
                <button
                  className="anchor-tag"
                  type="button"
                  onClick={() => navigate("/sign-in/parent")}
                >
                  Sign In
                </button>
              </p>
            </FlexWrapper>
          </form>
        </Container>
      </LoginLayout>

      {showSuccessPopUp && (
        <PopUpWrapper>
          <PopUpContainer>
            <Icon name="signsuccess" />
            <span className="close-icon" onClick={onCancel}>
              <Icon name="close" />
            </span>
            <PopUpTitle>Sign up completed!</PopUpTitle>
            <PopUpSubTitle>
              Thank you for signing up kazoobadoo
            </PopUpSubTitle>
            <PopUpText>Please check your inbox and click on the verification link to verify your account</PopUpText>
          </PopUpContainer>
      </PopUpWrapper>
      )}
    </>
  )
}
//   else {
//     return (
//       <LoginLayout path="" label="">
//         <SuccessContainer>
//           <Icon name="signsuccess" />
//           <SuccessHeading>Sign Up completed!</SuccessHeading>
//           <SuccessText>
//             Your Parent account has been created successfully.
//           </SuccessText>
//           <TextCenter className="mb-2">
//             <button
//               className="anchor-tag"
//               type="button"
//               onClick={() => navigate("/payment")}
//             >
//               Click Here
//             </button>
//             to continue for Adult Verfication.
//             {/* to sign in, view and add Child(s) to your account. */}
//           </TextCenter>
//           <Button
//             variant="newsecondary"
//             type="button"
//             onClick={() => navigate("/sign-in")}
//           >
//             Back
//           </Button>
//         </SuccessContainer>
//       </LoginLayout>
//     );
//   }
// }
